import axios from 'axios'
import React from 'react'
import { useState } from 'react'
import Button from 'react-bootstrap/Button'
import { useToasts } from 'react-toast-notifications';

const buttonStyle = {
  borderRadius: '100px',
  border: 0
}

const PResendEmail = () => {
  const { addToast } = useToasts();

  const [isLoading, setIsLoading] = useState(false)

  const handleResendEmail = async () => {
    setIsLoading(true)
    await axios.post(`/api/email/resend`)
      .then((response) => {
        console.log({ response })
        addToast('Verification link sent successfully', { appearance: 'success', autoDismiss: true });
      })
      .catch(error => {
        console.log({ error })
        addToast('Unable to send verification email', { appearance: 'error', autoDismiss: true });
      })
      .finally(() => {
        setIsLoading(false)
      })
  }
  return (
    <div className="email-alert alert-danger shadow-sm mb-4">
      <strong>URGENT:</strong> Please check your email to confirm your account. Otherwise your account will be suspended. <Button style={buttonStyle} variant="light" onClick={handleResendEmail} disabled={isLoading}>{ isLoading ? 'Sending email...' : 'Resend Email' }</Button>
    </div>
  )
}

export default PResendEmail;
